import React from "react";
import { GetStaticProps } from "next";

import { serialize } from "next-mdx-remote/serialize";

import ApplicationLayout from "components/ApplicationLayout";
import Navbar from "components/Navbar";
import PageContent from "components/PageContent";
import SharedFooter from "components/SharedFooter";
import { fetchChangelogEntries } from "lib/api";

import styles from "/styles/changelog.module.css";

import Container from "components/Container";
import ChangelogEntry from "components/ChangelogEntry";

import type { PropTypes as ChangelogEntryType } from "components/ChangelogEntry";
import type { Page } from "types/page";

type PageProps = {
  changelogEntries: ChangelogEntryType[];
};

export const getStaticProps: GetStaticProps<PageProps> = async () => {
  const changelogEntries = await fetchChangelogEntries();
  const promisesWithMdxSerialization = changelogEntries.map(async (entry) => ({
    ...entry,
    mdxSource: entry.body ? await serialize(entry.body) : null,
  }));

  return {
    props: {
      changelogEntries: await Promise.all(promisesWithMdxSerialization),
    },
  };
};

const Changelog: Page<PageProps> = ({ changelogEntries }) => {
  return (
    <div className={styles.changelogContainer}>
      <Container size="sm">
        <div className={styles.header}>
          <h1>Changelog</h1>
        </div>
        {changelogEntries.map((changelogEntry, index) => (
          <ChangelogEntry {...changelogEntry} key={index} />
        ))}
      </Container>
    </div>
  );
};

Changelog.getLayout = (page) => {
  return (
    <ApplicationLayout>
      <Navbar />
      <PageContent>{page}</PageContent>
      <SharedFooter />
    </ApplicationLayout>
  );
};

export default Changelog;
